import { useInfiniteQuery } from '@tanstack/react-query'
import { BookingsApi } from '../../api'
import { QueryKeys } from './constants'
import { Booking, GetBookingsRequest } from '../types'
import { useEffect, useMemo } from 'react'
import { adaptBookingDTO } from 'entities/bookings/model/adapters/adaptBookingDTO'

export const useGetBookingsListQuery = (
    filter?: GetBookingsRequest,
    options?: { refetchInterval: number },
) => {
    const {
        data,
        error,
        isError,
        isLoading,
        isSuccess,
        refetch,
        status,
        isFetching,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
    } = useInfiniteQuery({
        queryKey: [QueryKeys.GetAllBookings, Object.values(filter ?? {})],
        queryFn: ({ pageParam = 1 }) =>
            BookingsApi.getBookings(filter, {
                page: pageParam,
                size: 50,
            }),
        getNextPageParam: lastPage => {
            const { current_page, total_pages } = (lastPage as any).pagination
            return current_page < total_pages ? current_page + 1 : undefined
        },
        initialPageParam: 1,
        refetchInterval: options?.refetchInterval,
    })

    useEffect(() => {
        if (data && hasNextPage && !isFetchingNextPage) {
            fetchNextPage().then()
        }
    }, [data, hasNextPage, isFetchingNextPage])

    const allBooking = useMemo(() => {
        const bookings = data?.pages?.flatMap(page => page.bookings) || []
        const validBookings = bookings?.filter(
            booking =>
                booking?.area && booking?.counterparty && booking?.order_id,
        )
        return validBookings.map(adaptBookingDTO)
    }, [hasNextPage, data])

    return {
        bookings: allBooking as Booking[],
        error,
        status,
        refetch,
        isSuccess,
        isLoading,
        isError,
        isFetching,
    }
}
